<div class="page-breadcrumb">
    <div class="row">
        <div class="col-7 align-self-center">

            <h4 class="page-title">Change Password</h4>
        </div>

    </div>
</div>
<div>

    <div class="container-fluid" >
        <!-- ============================================================== -->
        <!-- Start Page Content -->
        <!-- ============================================================== -->
        <div class="row">
            <!-- Column -->
            <div class="col-lg-8">
                <div class="card" style="margin-top: 22px;">
                    <div class="card-body">
                        <form chnagePassword="ngForm">
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group row">
                                        <div class="col-6">
                                            <input class="form-control form-control-lg" type="password" #id="ngModel" name="id" required  [(ngModel)]="forgotPassWordAddObj.currentPassword"
                                                placeholder="Current Password">
                                        </div>
                                    </div>
                                        <div class="form-group row">
                                            <div class="col-6">
                                                <input class="form-control form-control-lg" type="password" #id="ngModel" name="id" required  [(ngModel)]="forgotPassWordAddObj.resetPassword"
                                                    placeholder="New Password">
                                            </div>
                                        </div>
                                        <div class="form-group row">
                                            <div class="col-6">
                                                <input class="form-control form-control-lg" type="password" #id="ngModel" name="id" required [(ngModel)]="confirmPassword"
                                                    placeholder="Confirm Password">
                                            </div>
                                        </div>
                                       
                                </div>
                            </div>
    
                         
                          
                         
                            <div class="form-actions m-t-40">
                                <button type="submit" style="background-color: #353556;color:white" class="btn" (click)="changePassword()" 
                                   >
                                    <i class="fa fa-check"></i> Submit</button> &nbsp;&nbsp;
                                

                            </div>
                      
                        </form>
                    </div>
                </div>
            </div>
            <!-- Column -->
        </div>
        <!-- ============================================================== -->
        <!-- End PAge Content -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Right sidebar -->
        <!-- ============================================================== -->
        <!-- .right-sidebar -->
        <!-- ============================================================== -->
        <!-- End Right sidebar -->
        <!-- ============================================================== -->
    </div>
    <!-- ============================================================== -->
    <!-- End Container fluid  -->
    <!-- ============================================================== -->
    <!-- ============================================================== -->

    <!-- ============================================================== -->
</div>